export default __webpack_public_path__ + "static/work-stranger-things-372505df52659fdb2f3cadb67a94043b.jpg";